/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './Notification.style';

type Props = {
  children: React.Node,
  elevation?: number,
};

const useStyles = createUseStyles(styles);

const Notification = ({ children, elevation }: Props): React.Node => {
  const classes: Object = useStyles({ elevation });

  return <div className={classes.root}>{children}</div>;
};

export default compose(React.memo)(Notification);
